import useSyncCalendar from '@/queries/sync-calendar.queries';

export default function useCalendarsSyncSection() {
	const { handleSyncGoogle, handleSyncMicrosoft } = useSyncCalendar();

	return {
		handleSyncGoogle,
		handleSyncMicrosoft,
	};
}
